import { render, staticRenderFns } from "./abmButtonsPresupuestosInternos.vue?vue&type=template&id=388bd422&"
import script from "./abmButtonsPresupuestosInternos.vue?vue&type=script&lang=js&"
export * from "./abmButtonsPresupuestosInternos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports